var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field-input",class:{'show-image': _vm.src_img}},[_c('p',{staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"}},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label.toUpperCase()))]):_vm._e(),_vm._t("checkbox")],2),_vm._t("default"),_c('img',{attrs:{"src":_vm.src_img,"alt":""}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }